import type { ReactNode } from 'react'

import styled from 'styled-components'

import { breakpoints } from '../breakPoints'

interface ProductListingLayoutProps {
  children: ReactNode
  filters: ReactNode
}

export function ProductListingLayout({ children, filters }: ProductListingLayoutProps) {
  return (
    <Layout>
      <DesktopFilters>{filters}</DesktopFilters>
      <ProductsColumn>{children}</ProductsColumn>
    </Layout>
  )
}

export const MobileTabletFilterAction = styled.div`
  display: flex;

  @media (width >= ${breakpoints.desktopMin}) {
    display: none;
  }
`

const Layout = styled.div`
  display: block;
  width: 100%;

  @media (width >= ${breakpoints.desktopMin}) {
    display: grid;
    grid-template-columns: 327px minmax(0, 1fr);
    align-items: start;
    gap: 20px;
  }
`

const DesktopFilters = styled.aside`
  display: none;

  @media (width >= ${breakpoints.desktopMin}) {
    position: sticky;
    top: 16px;
    display: block;
    width: 327px;
    max-height: calc(100vh - 32px);
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;

    & > div {
      box-sizing: border-box;
      position: static;
      max-width: 100%;
      width: 100%;
      height: auto;
      min-height: 0;
      padding: 0 20px 0 0;
    }
  }
`

const ProductsColumn = styled.div`
  min-width: 0;
  width: 100%;
`
